import {
    MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT,
    MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT,
    MULTI_LOAN_DASHBOARD_READY
} from './Dashboard.actions';
import { LEAVE_DASHBOARD } from '../dashboard/Dashboard.actions';
import { Action } from 'redux';

const initialState = {
    ready: false,
    disableRedirect: false
};
// eslint-disable-next-line import/no-default-export
export default function (state = initialState, action: Action) {
    switch (action.type) {
        case MULTI_LOAN_DASHBOARD_READY:
            return {
                ...state,
                ready: true
            };
        case MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT:
            return {
                ...state,
                disableRedirect: true
            };
        case MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT:
            return {
                ...state,
                disableRedirect: false
            };
        case LEAVE_DASHBOARD:
            return initialState;
        default:
            return state;
    }
}
